// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ApiDocsRouteImport } from './routes/api-docs'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CancellationRouteImport } from './routes/cancellation'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ConfianzaRouteImport } from './routes/confianza'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DisenaMiViajeRouteImport } from './routes/disena-mi-viaje'
import { Route as ExploraRouteImport } from './routes/explora'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FlightsRouteImport } from './routes/flights'
import { Route as HelpRouteImport } from './routes/help'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RetoRouteImport } from './routes/reto'
import { Route as TerminosRouteImport } from './routes/terminos'
import { Route as VerdeRouteImport } from './routes/verde'
import { Route as VuelosRouteImport } from './routes/vuelos'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedMiCuentaRouteImport } from './routes/_authenticated/mi-cuenta'
import { Route as AudioguiaTourSlugRouteImport } from './routes/audioguia.$tourSlug'
import { Route as BlogCdmxRouteImport } from './routes/blog_.cdmx'
import { Route as BookingCodeRouteImport } from './routes/booking.$code'
import { Route as BookingReturnRouteImport } from './routes/booking.return'
import { Route as ConciergePresetRouteImport } from './routes/concierge.$preset'
import { Route as DestinoSlugRouteImport } from './routes/destino.$slug'
import { Route as DestinosIndexRouteImport } from './routes/destinos.index'
import { Route as DestinosStateRouteImport } from './routes/destinos.$state'
import { Route as ExperienciaCodeRouteImport } from './routes/experiencia.$code'
import { Route as FlightsDetailsRouteImport } from './routes/flights.details'
import { Route as GuiaMonteAlbanRouteImport } from './routes/guia.monte-alban'
import { Route as MayaIndexRouteImport } from './routes/maya.index'
import { Route as MayaSlugRouteImport } from './routes/maya.$slug'
import { Route as MayaReturnRouteImport } from './routes/maya.return'
import { Route as ProductsIdRouteImport } from './routes/products.$id'
import { Route as ReservaPruebaCodeRouteImport } from './routes/reserva-prueba.$code'
import { Route as ReservaCodeRouteImport } from './routes/reserva.$code'
import { Route as ReservarPruebaActivityIdRouteImport } from './routes/reservar-prueba.$activityId'
import { Route as ReviewTokenRouteImport } from './routes/review.$token'
import { Route as TourDestinationDestinationRouteImport } from './routes/tour-destination.$destination'
import { Route as TourSlugRouteImport } from './routes/tour.$slug'
import { Route as ToursIndexRouteImport } from './routes/tours.index'
import { Route as ToursCityRouteImport } from './routes/tours.$city'
import { Route as LangTourSlugRouteImport } from './routes/$lang.tour.$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin/analytics'
import { Route as AuthenticatedAdminBokunStatusRouteImport } from './routes/_authenticated/admin.bokun-status'
import { Route as AuthenticatedAdminBokunSyncRouteImport } from './routes/_authenticated/admin.bokun-sync'
import { Route as AuthenticatedAdminBokunTestRouteImport } from './routes/_authenticated/admin.bokun-test'
import { Route as AuthenticatedAdminBuenFinRouteImport } from './routes/_authenticated/admin/buen-fin'
import { Route as AuthenticatedAdminConciergeLinksRouteImport } from './routes/_authenticated/admin/concierge-links'
import { Route as AuthenticatedAdminContactRequestsRouteImport } from './routes/_authenticated/admin/contact-requests'
import { Route as AuthenticatedAdminCozumelNlLinksRouteImport } from './routes/_authenticated/admin/cozumel-nl-links'
import { Route as AuthenticatedAdminCustomersRouteImport } from './routes/_authenticated/admin/customers'
import { Route as AuthenticatedAdminDashboardRouteImport } from './routes/_authenticated/admin/dashboard'
import { Route as AuthenticatedAdminErrorsRouteImport } from './routes/_authenticated/admin/errors'
import { Route as AuthenticatedAdminExternalBookingsRouteImport } from './routes/_authenticated/admin/external-bookings'
import { Route as AuthenticatedAdminFotosViajerosRouteImport } from './routes/_authenticated/admin/fotos-viajeros'
import { Route as AuthenticatedAdminImportHistoryRouteImport } from './routes/_authenticated/admin/import-history'
import { Route as AuthenticatedAdminIntegrationsRouteImport } from './routes/_authenticated/admin.integrations'
import { Route as AuthenticatedAdminMayaRouteImport } from './routes/_authenticated/admin.maya'
import { Route as AuthenticatedAdminMayaPreviewPlaysRouteImport } from './routes/_authenticated/admin/maya-preview-plays'
import { Route as AuthenticatedAdminMayaRevenueRecoveryRouteImport } from './routes/_authenticated/admin/maya-revenue-recovery'
import { Route as AuthenticatedAdminMayaTourContentRouteImport } from './routes/_authenticated/admin/maya-tour-content'
import { Route as AuthenticatedAdminMcpConnectionsRouteImport } from './routes/_authenticated/admin.mcp-connections'
import { Route as AuthenticatedAdminMcpDiagnosticsRouteImport } from './routes/_authenticated/admin.mcp-diagnostics'
import { Route as AuthenticatedAdminMonitoringRouteImport } from './routes/_authenticated/admin/monitoring'
import { Route as AuthenticatedAdminOpsLogsRouteImport } from './routes/_authenticated/admin/ops-logs'
import { Route as AuthenticatedAdminOtaBookingsRouteImport } from './routes/_authenticated/admin/ota-bookings'
import { Route as AuthenticatedAdminProviderCortesRouteImport } from './routes/_authenticated/admin/provider-cortes'
import { Route as AuthenticatedAdminProviderManagementRouteImport } from './routes/_authenticated/admin/provider-management'
import { Route as AuthenticatedAdminProviderPayablesRouteImport } from './routes/_authenticated/admin/provider-payables'
import { Route as AuthenticatedAdminProviderPaymentsRouteImport } from './routes/_authenticated/admin/provider-payments'
import { Route as AuthenticatedAdminProviderReconciliationRouteImport } from './routes/_authenticated/admin/provider-reconciliation'
import { Route as AuthenticatedAdminProviderReportsRouteImport } from './routes/_authenticated/admin/provider-reports'
import { Route as AuthenticatedAdminProvidersRouteImport } from './routes/_authenticated/admin/providers'
import { Route as AuthenticatedAdminReembolsosRouteImport } from './routes/_authenticated/admin/reembolsos'
import { Route as AuthenticatedAdminReportePreciosTtdRouteImport } from './routes/_authenticated/admin/reporte-precios-ttd'
import { Route as AuthenticatedAdminReportsRouteImport } from './routes/_authenticated/admin/reports'
import { Route as AuthenticatedAdminReviewsRouteImport } from './routes/_authenticated/admin/reviews'
import { Route as AuthenticatedAdminSeguridadRouteImport } from './routes/_authenticated/admin/seguridad'
import { Route as AuthenticatedAdminSiteMediaRouteImport } from './routes/_authenticated/admin/site-media'
import { Route as AuthenticatedAdminStripeEventsRouteImport } from './routes/_authenticated/admin/stripe-events'
import { Route as AuthenticatedAdminStripeReconciliationRouteImport } from './routes/_authenticated/admin/stripe-reconciliation'
import { Route as AuthenticatedAdminStripeWebhooksRouteImport } from './routes/_authenticated/admin/stripe-webhooks'
import { Route as AuthenticatedAdminTourAliasesRouteImport } from './routes/_authenticated/admin/tour-aliases'
import { Route as AuthenticatedAdminTourBookingLinksRouteImport } from './routes/_authenticated/admin/tour-booking-links'
import { Route as AuthenticatedAdminTraduccionesTitulosRouteImport } from './routes/_authenticated/admin/traducciones-titulos'
import { Route as AuthenticatedAdminTravelpayoutsStatusRouteImport } from './routes/_authenticated/admin.travelpayouts-status'
import { Route as AuthenticatedAdminVideosRouteImport } from './routes/_authenticated/admin/videos'
import { Route as AuthenticatedPartnerIndexRouteImport } from './routes/_authenticated/partner.index'
import { Route as AuthenticatedPartnerApiKeysRouteImport } from './routes/_authenticated/partner.api-keys'
import { Route as AuthenticatedPartnerWebhooksRouteImport } from './routes/_authenticated/partner.webhooks'
import { Route as AuthenticatedSeguridadMfaRouteImport } from './routes/_authenticated/seguridad.mfa'
import { Route as GidsCozumelTokenRouteImport } from './routes/gids.cozumel.$token'
import { Route as MayaInviteTokenRouteImport } from './routes/maya.invite.$token'
import { Route as AuthenticatedAdminAudioguiasIndexRouteImport } from './routes/_authenticated/admin/audioguias.index'
import { Route as AuthenticatedAdminAudioguiasIdRouteImport } from './routes/_authenticated/admin/audioguias.$id'
import { Route as AuthenticatedAdminBookingsIndexRouteImport } from './routes/_authenticated/admin/bookings.index'
import { Route as AuthenticatedAdminProviderCortesIdRouteImport } from './routes/_authenticated/admin/provider-cortes_.$id'
import { Route as AuthenticatedAdminSecuritySetupMfaRouteImport } from './routes/_authenticated/admin/security.setup-mfa'
import { Route as AuthenticatedAdminSecurityVerifyMfaRouteImport } from './routes/_authenticated/admin/security.verify-mfa'
import { Route as AuthenticatedAdminToursIndexRouteImport } from './routes/_authenticated/admin/tours.index'
import { Route as AuthenticatedAdminToursNewRouteImport } from './routes/_authenticated/admin/tours.new'
import { Route as AuthenticatedPartnerWebhooksDeliveriesRouteImport } from './routes/_authenticated/partner.webhooks_.deliveries'
import { Route as TourDestinationDestinationPagePageRouteImport } from './routes/tour-destination.$destination.page.$page'
import { Route as AuthenticatedAdminToursIdEditRouteImport } from './routes/_authenticated/admin/tours.$id.edit'
import { Route as AuthenticatedAdminToursIdInventoryRouteImport } from './routes/_authenticated/admin/tours.$id.inventory'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ApiDocsRoute = ApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CancellationRoute = CancellationRouteImport.update({
            id: '/cancellation',path: '/cancellation',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ConfianzaRoute = ConfianzaRouteImport.update({
            id: '/confianza',path: '/confianza',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DisenaMiViajeRoute = DisenaMiViajeRouteImport.update({
            id: '/disena-mi-viaje',path: '/disena-mi-viaje',getParentRoute: () => rootRouteImport
          })
const ExploraRoute = ExploraRouteImport.update({
            id: '/explora',path: '/explora',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FlightsRoute = FlightsRouteImport.update({
            id: '/flights',path: '/flights',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RetoRoute = RetoRouteImport.update({
            id: '/reto',path: '/reto',getParentRoute: () => rootRouteImport
          })
const TerminosRoute = TerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => rootRouteImport
          })
const VerdeRoute = VerdeRouteImport.update({
            id: '/verde',path: '/verde',getParentRoute: () => rootRouteImport
          })
const VuelosRoute = VuelosRouteImport.update({
            id: '/vuelos',path: '/vuelos',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMiCuentaRoute = AuthenticatedMiCuentaRouteImport.update({
            id: '/mi-cuenta',path: '/mi-cuenta',getParentRoute: () => AuthenticatedRouteRoute
          })
const AudioguiaTourSlugRoute = AudioguiaTourSlugRouteImport.update({
            id: '/audioguia/$tourSlug',path: '/audioguia/$tourSlug',getParentRoute: () => rootRouteImport
          })
const BlogCdmxRoute = BlogCdmxRouteImport.update({
            id: '/blog_/cdmx',path: '/blog/cdmx',getParentRoute: () => rootRouteImport
          })
const BookingCodeRoute = BookingCodeRouteImport.update({
            id: '/booking/$code',path: '/booking/$code',getParentRoute: () => rootRouteImport
          })
const BookingReturnRoute = BookingReturnRouteImport.update({
            id: '/booking/return',path: '/booking/return',getParentRoute: () => rootRouteImport
          })
const ConciergePresetRoute = ConciergePresetRouteImport.update({
            id: '/concierge/$preset',path: '/concierge/$preset',getParentRoute: () => rootRouteImport
          })
const DestinoSlugRoute = DestinoSlugRouteImport.update({
            id: '/destino/$slug',path: '/destino/$slug',getParentRoute: () => rootRouteImport
          })
const DestinosIndexRoute = DestinosIndexRouteImport.update({
            id: '/destinos/',path: '/destinos/',getParentRoute: () => rootRouteImport
          })
const DestinosStateRoute = DestinosStateRouteImport.update({
            id: '/destinos/$state',path: '/destinos/$state',getParentRoute: () => rootRouteImport
          })
const ExperienciaCodeRoute = ExperienciaCodeRouteImport.update({
            id: '/experiencia/$code',path: '/experiencia/$code',getParentRoute: () => rootRouteImport
          })
const FlightsDetailsRoute = FlightsDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => FlightsRoute
          })
const GuiaMonteAlbanRoute = GuiaMonteAlbanRouteImport.update({
            id: '/guia/monte-alban',path: '/guia/monte-alban',getParentRoute: () => rootRouteImport
          })
const MayaIndexRoute = MayaIndexRouteImport.update({
            id: '/maya/',path: '/maya/',getParentRoute: () => rootRouteImport
          })
const MayaSlugRoute = MayaSlugRouteImport.update({
            id: '/maya/$slug',path: '/maya/$slug',getParentRoute: () => rootRouteImport
          })
const MayaReturnRoute = MayaReturnRouteImport.update({
            id: '/maya/return',path: '/maya/return',getParentRoute: () => rootRouteImport
          })
const ProductsIdRoute = ProductsIdRouteImport.update({
            id: '/products/$id',path: '/products/$id',getParentRoute: () => rootRouteImport
          })
const ReservaPruebaCodeRoute = ReservaPruebaCodeRouteImport.update({
            id: '/reserva-prueba/$code',path: '/reserva-prueba/$code',getParentRoute: () => rootRouteImport
          })
const ReservaCodeRoute = ReservaCodeRouteImport.update({
            id: '/reserva/$code',path: '/reserva/$code',getParentRoute: () => rootRouteImport
          })
const ReservarPruebaActivityIdRoute = ReservarPruebaActivityIdRouteImport.update({
            id: '/reservar-prueba/$activityId',path: '/reservar-prueba/$activityId',getParentRoute: () => rootRouteImport
          })
const ReviewTokenRoute = ReviewTokenRouteImport.update({
            id: '/review/$token',path: '/review/$token',getParentRoute: () => rootRouteImport
          })
const TourDestinationDestinationRoute = TourDestinationDestinationRouteImport.update({
            id: '/tour-destination/$destination',path: '/tour-destination/$destination',getParentRoute: () => rootRouteImport
          })
const TourSlugRoute = TourSlugRouteImport.update({
            id: '/tour/$slug',path: '/tour/$slug',getParentRoute: () => rootRouteImport
          })
const ToursIndexRoute = ToursIndexRouteImport.update({
            id: '/tours/',path: '/tours/',getParentRoute: () => rootRouteImport
          })
const ToursCityRoute = ToursCityRouteImport.update({
            id: '/tours/$city',path: '/tours/$city',getParentRoute: () => rootRouteImport
          })
const LangTourSlugRoute = LangTourSlugRouteImport.update({
            id: '/$lang/tour/$slug',path: '/$lang/tour/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAnalyticsRoute = AuthenticatedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBokunStatusRoute = AuthenticatedAdminBokunStatusRouteImport.update({
            id: '/bokun-status',path: '/bokun-status',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBokunSyncRoute = AuthenticatedAdminBokunSyncRouteImport.update({
            id: '/bokun-sync',path: '/bokun-sync',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBokunTestRoute = AuthenticatedAdminBokunTestRouteImport.update({
            id: '/bokun-test',path: '/bokun-test',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBuenFinRoute = AuthenticatedAdminBuenFinRouteImport.update({
            id: '/buen-fin',path: '/buen-fin',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminConciergeLinksRoute = AuthenticatedAdminConciergeLinksRouteImport.update({
            id: '/concierge-links',path: '/concierge-links',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminContactRequestsRoute = AuthenticatedAdminContactRequestsRouteImport.update({
            id: '/contact-requests',path: '/contact-requests',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminCozumelNlLinksRoute = AuthenticatedAdminCozumelNlLinksRouteImport.update({
            id: '/cozumel-nl-links',path: '/cozumel-nl-links',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminCustomersRoute = AuthenticatedAdminCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminDashboardRoute = AuthenticatedAdminDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminErrorsRoute = AuthenticatedAdminErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminExternalBookingsRoute = AuthenticatedAdminExternalBookingsRouteImport.update({
            id: '/external-bookings',path: '/external-bookings',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminFotosViajerosRoute = AuthenticatedAdminFotosViajerosRouteImport.update({
            id: '/fotos-viajeros',path: '/fotos-viajeros',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminImportHistoryRoute = AuthenticatedAdminImportHistoryRouteImport.update({
            id: '/import-history',path: '/import-history',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminIntegrationsRoute = AuthenticatedAdminIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMayaRoute = AuthenticatedAdminMayaRouteImport.update({
            id: '/maya',path: '/maya',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMayaPreviewPlaysRoute = AuthenticatedAdminMayaPreviewPlaysRouteImport.update({
            id: '/maya-preview-plays',path: '/maya-preview-plays',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMayaRevenueRecoveryRoute = AuthenticatedAdminMayaRevenueRecoveryRouteImport.update({
            id: '/maya-revenue-recovery',path: '/maya-revenue-recovery',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMayaTourContentRoute = AuthenticatedAdminMayaTourContentRouteImport.update({
            id: '/maya-tour-content',path: '/maya-tour-content',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMcpConnectionsRoute = AuthenticatedAdminMcpConnectionsRouteImport.update({
            id: '/mcp-connections',path: '/mcp-connections',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMcpDiagnosticsRoute = AuthenticatedAdminMcpDiagnosticsRouteImport.update({
            id: '/mcp-diagnostics',path: '/mcp-diagnostics',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminMonitoringRoute = AuthenticatedAdminMonitoringRouteImport.update({
            id: '/monitoring',path: '/monitoring',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminOpsLogsRoute = AuthenticatedAdminOpsLogsRouteImport.update({
            id: '/ops-logs',path: '/ops-logs',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminOtaBookingsRoute = AuthenticatedAdminOtaBookingsRouteImport.update({
            id: '/ota-bookings',path: '/ota-bookings',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProviderCortesRoute = AuthenticatedAdminProviderCortesRouteImport.update({
            id: '/provider-cortes',path: '/provider-cortes',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProviderManagementRoute = AuthenticatedAdminProviderManagementRouteImport.update({
            id: '/provider-management',path: '/provider-management',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProviderPayablesRoute = AuthenticatedAdminProviderPayablesRouteImport.update({
            id: '/provider-payables',path: '/provider-payables',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProviderPaymentsRoute = AuthenticatedAdminProviderPaymentsRouteImport.update({
            id: '/provider-payments',path: '/provider-payments',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProviderReconciliationRoute = AuthenticatedAdminProviderReconciliationRouteImport.update({
            id: '/provider-reconciliation',path: '/provider-reconciliation',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProviderReportsRoute = AuthenticatedAdminProviderReportsRouteImport.update({
            id: '/provider-reports',path: '/provider-reports',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProvidersRoute = AuthenticatedAdminProvidersRouteImport.update({
            id: '/providers',path: '/providers',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReembolsosRoute = AuthenticatedAdminReembolsosRouteImport.update({
            id: '/reembolsos',path: '/reembolsos',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReportePreciosTtdRoute = AuthenticatedAdminReportePreciosTtdRouteImport.update({
            id: '/reporte-precios-ttd',path: '/reporte-precios-ttd',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReportsRoute = AuthenticatedAdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminReviewsRoute = AuthenticatedAdminReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSeguridadRoute = AuthenticatedAdminSeguridadRouteImport.update({
            id: '/seguridad',path: '/seguridad',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSiteMediaRoute = AuthenticatedAdminSiteMediaRouteImport.update({
            id: '/site-media',path: '/site-media',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminStripeEventsRoute = AuthenticatedAdminStripeEventsRouteImport.update({
            id: '/stripe-events',path: '/stripe-events',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminStripeReconciliationRoute = AuthenticatedAdminStripeReconciliationRouteImport.update({
            id: '/stripe-reconciliation',path: '/stripe-reconciliation',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminStripeWebhooksRoute = AuthenticatedAdminStripeWebhooksRouteImport.update({
            id: '/stripe-webhooks',path: '/stripe-webhooks',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminTourAliasesRoute = AuthenticatedAdminTourAliasesRouteImport.update({
            id: '/tour-aliases',path: '/tour-aliases',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminTourBookingLinksRoute = AuthenticatedAdminTourBookingLinksRouteImport.update({
            id: '/tour-booking-links',path: '/tour-booking-links',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminTraduccionesTitulosRoute = AuthenticatedAdminTraduccionesTitulosRouteImport.update({
            id: '/traducciones-titulos',path: '/traducciones-titulos',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminTravelpayoutsStatusRoute = AuthenticatedAdminTravelpayoutsStatusRouteImport.update({
            id: '/travelpayouts-status',path: '/travelpayouts-status',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminVideosRoute = AuthenticatedAdminVideosRouteImport.update({
            id: '/videos',path: '/videos',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedPartnerIndexRoute = AuthenticatedPartnerIndexRouteImport.update({
            id: '/partner/',path: '/partner/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerApiKeysRoute = AuthenticatedPartnerApiKeysRouteImport.update({
            id: '/partner/api-keys',path: '/partner/api-keys',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPartnerWebhooksRoute = AuthenticatedPartnerWebhooksRouteImport.update({
            id: '/partner/webhooks',path: '/partner/webhooks',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSeguridadMfaRoute = AuthenticatedSeguridadMfaRouteImport.update({
            id: '/seguridad/mfa',path: '/seguridad/mfa',getParentRoute: () => AuthenticatedRouteRoute
          })
const GidsCozumelTokenRoute = GidsCozumelTokenRouteImport.update({
            id: '/gids/cozumel/$token',path: '/gids/cozumel/$token',getParentRoute: () => rootRouteImport
          })
const MayaInviteTokenRoute = MayaInviteTokenRouteImport.update({
            id: '/maya/invite/$token',path: '/maya/invite/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminAudioguiasIndexRoute = AuthenticatedAdminAudioguiasIndexRouteImport.update({
            id: '/audioguias/',path: '/audioguias/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminAudioguiasIdRoute = AuthenticatedAdminAudioguiasIdRouteImport.update({
            id: '/audioguias/$id',path: '/audioguias/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminBookingsIndexRoute = AuthenticatedAdminBookingsIndexRouteImport.update({
            id: '/bookings/',path: '/bookings/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminProviderCortesIdRoute = AuthenticatedAdminProviderCortesIdRouteImport.update({
            id: '/provider-cortes_/$id',path: '/provider-cortes/$id',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSecuritySetupMfaRoute = AuthenticatedAdminSecuritySetupMfaRouteImport.update({
            id: '/security/setup-mfa',path: '/security/setup-mfa',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminSecurityVerifyMfaRoute = AuthenticatedAdminSecurityVerifyMfaRouteImport.update({
            id: '/security/verify-mfa',path: '/security/verify-mfa',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminToursIndexRoute = AuthenticatedAdminToursIndexRouteImport.update({
            id: '/tours/',path: '/tours/',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminToursNewRoute = AuthenticatedAdminToursNewRouteImport.update({
            id: '/tours/new',path: '/tours/new',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedPartnerWebhooksDeliveriesRoute = AuthenticatedPartnerWebhooksDeliveriesRouteImport.update({
            id: '/partner/webhooks_/deliveries',path: '/partner/webhooks/deliveries',getParentRoute: () => AuthenticatedRouteRoute
          })
const TourDestinationDestinationPagePageRoute = TourDestinationDestinationPagePageRouteImport.update({
            id: '/page/$page',path: '/page/$page',getParentRoute: () => TourDestinationDestinationRoute
          })
const AuthenticatedAdminToursIdEditRoute = AuthenticatedAdminToursIdEditRouteImport.update({
            id: '/tours/$id/edit',path: '/tours/$id/edit',getParentRoute: () => AuthenticatedAdminRouteRoute
          })
const AuthenticatedAdminToursIdInventoryRoute = AuthenticatedAdminToursIdInventoryRouteImport.update({
            id: '/tours/$id/inventory',path: '/tours/$id/inventory',getParentRoute: () => AuthenticatedAdminRouteRoute
          })





const AuthenticatedAdminRouteRouteChildren = {
  AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,AuthenticatedAdminBokunStatusRoute: AuthenticatedAdminBokunStatusRoute,AuthenticatedAdminBokunSyncRoute: AuthenticatedAdminBokunSyncRoute,AuthenticatedAdminBokunTestRoute: AuthenticatedAdminBokunTestRoute,AuthenticatedAdminBuenFinRoute: AuthenticatedAdminBuenFinRoute,AuthenticatedAdminConciergeLinksRoute: AuthenticatedAdminConciergeLinksRoute,AuthenticatedAdminContactRequestsRoute: AuthenticatedAdminContactRequestsRoute,AuthenticatedAdminCozumelNlLinksRoute: AuthenticatedAdminCozumelNlLinksRoute,AuthenticatedAdminCustomersRoute: AuthenticatedAdminCustomersRoute,AuthenticatedAdminDashboardRoute: AuthenticatedAdminDashboardRoute,AuthenticatedAdminErrorsRoute: AuthenticatedAdminErrorsRoute,AuthenticatedAdminExternalBookingsRoute: AuthenticatedAdminExternalBookingsRoute,AuthenticatedAdminFotosViajerosRoute: AuthenticatedAdminFotosViajerosRoute,AuthenticatedAdminImportHistoryRoute: AuthenticatedAdminImportHistoryRoute,AuthenticatedAdminIntegrationsRoute: AuthenticatedAdminIntegrationsRoute,AuthenticatedAdminMayaRoute: AuthenticatedAdminMayaRoute,AuthenticatedAdminMayaPreviewPlaysRoute: AuthenticatedAdminMayaPreviewPlaysRoute,AuthenticatedAdminMayaRevenueRecoveryRoute: AuthenticatedAdminMayaRevenueRecoveryRoute,AuthenticatedAdminMayaTourContentRoute: AuthenticatedAdminMayaTourContentRoute,AuthenticatedAdminMcpConnectionsRoute: AuthenticatedAdminMcpConnectionsRoute,AuthenticatedAdminMcpDiagnosticsRoute: AuthenticatedAdminMcpDiagnosticsRoute,AuthenticatedAdminMonitoringRoute: AuthenticatedAdminMonitoringRoute,AuthenticatedAdminOpsLogsRoute: AuthenticatedAdminOpsLogsRoute,AuthenticatedAdminOtaBookingsRoute: AuthenticatedAdminOtaBookingsRoute,AuthenticatedAdminProviderCortesRoute: AuthenticatedAdminProviderCortesRoute,AuthenticatedAdminProviderManagementRoute: AuthenticatedAdminProviderManagementRoute,AuthenticatedAdminProviderPayablesRoute: AuthenticatedAdminProviderPayablesRoute,AuthenticatedAdminProviderPaymentsRoute: AuthenticatedAdminProviderPaymentsRoute,AuthenticatedAdminProviderReconciliationRoute: AuthenticatedAdminProviderReconciliationRoute,AuthenticatedAdminProviderReportsRoute: AuthenticatedAdminProviderReportsRoute,AuthenticatedAdminProvidersRoute: AuthenticatedAdminProvidersRoute,AuthenticatedAdminReembolsosRoute: AuthenticatedAdminReembolsosRoute,AuthenticatedAdminReportePreciosTtdRoute: AuthenticatedAdminReportePreciosTtdRoute,AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,AuthenticatedAdminReviewsRoute: AuthenticatedAdminReviewsRoute,AuthenticatedAdminSeguridadRoute: AuthenticatedAdminSeguridadRoute,AuthenticatedAdminSiteMediaRoute: AuthenticatedAdminSiteMediaRoute,AuthenticatedAdminStripeEventsRoute: AuthenticatedAdminStripeEventsRoute,AuthenticatedAdminStripeReconciliationRoute: AuthenticatedAdminStripeReconciliationRoute,AuthenticatedAdminStripeWebhooksRoute: AuthenticatedAdminStripeWebhooksRoute,AuthenticatedAdminTourAliasesRoute: AuthenticatedAdminTourAliasesRoute,AuthenticatedAdminTourBookingLinksRoute: AuthenticatedAdminTourBookingLinksRoute,AuthenticatedAdminTraduccionesTitulosRoute: AuthenticatedAdminTraduccionesTitulosRoute,AuthenticatedAdminTravelpayoutsStatusRoute: AuthenticatedAdminTravelpayoutsStatusRoute,AuthenticatedAdminVideosRoute: AuthenticatedAdminVideosRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminAudioguiasIdRoute: AuthenticatedAdminAudioguiasIdRoute,AuthenticatedAdminProviderCortesIdRoute: AuthenticatedAdminProviderCortesIdRoute,AuthenticatedAdminSecuritySetupMfaRoute: AuthenticatedAdminSecuritySetupMfaRoute,AuthenticatedAdminSecurityVerifyMfaRoute: AuthenticatedAdminSecurityVerifyMfaRoute,AuthenticatedAdminToursNewRoute: AuthenticatedAdminToursNewRoute,AuthenticatedAdminAudioguiasIndexRoute: AuthenticatedAdminAudioguiasIndexRoute,AuthenticatedAdminBookingsIndexRoute: AuthenticatedAdminBookingsIndexRoute,AuthenticatedAdminToursIndexRoute: AuthenticatedAdminToursIndexRoute,AuthenticatedAdminToursIdEditRoute: AuthenticatedAdminToursIdEditRoute,AuthenticatedAdminToursIdInventoryRoute: AuthenticatedAdminToursIdInventoryRoute
}

const AuthenticatedAdminRouteRouteWithChildren = AuthenticatedAdminRouteRoute._addFileChildren(AuthenticatedAdminRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,AuthenticatedMiCuentaRoute: AuthenticatedMiCuentaRoute,AuthenticatedPartnerApiKeysRoute: AuthenticatedPartnerApiKeysRoute,AuthenticatedPartnerWebhooksRoute: AuthenticatedPartnerWebhooksRoute,AuthenticatedSeguridadMfaRoute: AuthenticatedSeguridadMfaRoute,AuthenticatedPartnerIndexRoute: AuthenticatedPartnerIndexRoute,AuthenticatedPartnerWebhooksDeliveriesRoute: AuthenticatedPartnerWebhooksDeliveriesRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const FlightsRouteChildren = {
  FlightsDetailsRoute: FlightsDetailsRoute
}

const FlightsRouteWithChildren = FlightsRoute._addFileChildren(FlightsRouteChildren)




const TourDestinationDestinationRouteChildren = {
  TourDestinationDestinationPagePageRoute: TourDestinationDestinationPagePageRoute
}

const TourDestinationDestinationRouteWithChildren = TourDestinationDestinationRoute._addFileChildren(TourDestinationDestinationRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,ApiDocsRoute: ApiDocsRoute,AuthRoute: AuthRoute,BlogRoute: BlogRoute,CancellationRoute: CancellationRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ConfianzaRoute: ConfianzaRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DisenaMiViajeRoute: DisenaMiViajeRoute,ExploraRoute: ExploraRoute,FaqRoute: FaqRoute,FlightsRoute: FlightsRouteWithChildren,HelpRoute: HelpRoute,LoginRoute: LoginRoute,PrivacidadRoute: PrivacidadRoute,ResetPasswordRoute: ResetPasswordRoute,RetoRoute: RetoRoute,TerminosRoute: TerminosRoute,VerdeRoute: VerdeRoute,VuelosRoute: VuelosRoute,AudioguiaTourSlugRoute: AudioguiaTourSlugRoute,BlogCdmxRoute: BlogCdmxRoute,BookingCodeRoute: BookingCodeRoute,BookingReturnRoute: BookingReturnRoute,ConciergePresetRoute: ConciergePresetRoute,DestinoSlugRoute: DestinoSlugRoute,DestinosStateRoute: DestinosStateRoute,ExperienciaCodeRoute: ExperienciaCodeRoute,GuiaMonteAlbanRoute: GuiaMonteAlbanRoute,MayaSlugRoute: MayaSlugRoute,MayaReturnRoute: MayaReturnRoute,ProductsIdRoute: ProductsIdRoute,ReservaPruebaCodeRoute: ReservaPruebaCodeRoute,ReservaCodeRoute: ReservaCodeRoute,ReservarPruebaActivityIdRoute: ReservarPruebaActivityIdRoute,ReviewTokenRoute: ReviewTokenRoute,TourDestinationDestinationRoute: TourDestinationDestinationRouteWithChildren,TourSlugRoute: TourSlugRoute,ToursCityRoute: ToursCityRoute,DestinosIndexRoute: DestinosIndexRoute,MayaIndexRoute: MayaIndexRoute,ToursIndexRoute: ToursIndexRoute,LangTourSlugRoute: LangTourSlugRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,GidsCozumelTokenRoute: GidsCozumelTokenRoute,MayaInviteTokenRoute: MayaInviteTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)